/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { ConfirmDialog } from '../ConfirmDialog';
import { useObjectContext } from '@/hooks/useObjectContext';
import { paths } from '@/app/routes';
import { useNavigate } from 'react-router-dom';
import { useListContactsQuery } from '@/features/contacts/contactsApi';

export const ConvertProspectToClientDialog = ({
	open,
	handleClose,
	additionalContent,
	content,
	deal,
}) => {
	const navigate = useNavigate();

	const { clientRow, insight } = useObjectContext();
	const clientId = clientRow?.clientId;

	const { data: contacts, ...contactQuery } = useListContactsQuery(clientId, {
		skip: !clientId,
		selectFromResult: ({ data, ...rest }) => {
			const contacts = data ?? [];
			return {
				...rest,
				data: contacts,
			};
		},
	});
	const contact = contacts?.find((c) => c.isMainContact);

	const address = insight?.AddressLine1;

	const hasDeal = deal && Object.keys(deal ?? {}).length > 0;

	const disableConfirm = hasDeal && !address;

	const handleConfirm = () => {
		handleClose();
		navigate(paths.createNewBusiness, { state: { client: clientRow, contact } });
	};

	return (
		<>
			{open && (
				<ConfirmDialog
					openDialog={open}
					handleClose={handleClose}
					handleConfirm={handleConfirm}
					disabled={disableConfirm}
					actionName={'convert to client'}
					{...(content
						? { content }
						: {
								additionalContent:
									additionalContent ??
									'Adding a new business will convert this prospect into a client.',
							})}
				/>
			)}
		</>
	);
};
